import React from 'react';

import { EType } from '../../../../repositories/journal/entities/journal/JournalAttributesSchema';
import { Details as DetailsComponent, DetailsSeparator } from '../../../Details';
import { DatePublished, DateTimePublished } from '../DatePublished';
import { NumViews } from '../NumViews';
import { RegionName } from '../RegionName';
import { BlogLink } from '../BlogLink';
import { PostCommentsCount } from '../../../PostCommentsCount';
import { AuthorLink } from '../AuthorLink';
import { IAuthorsLinkSchema } from '../../../../repositories/journal/entities/journal/AuthorsLinkSchema';
import { IPost } from '../../Post';
import * as s from './Details.css';

export interface IDetails
  extends Pick<
    IPost,
    | 'authorPostsCount'
    | 'authorId'
    | 'commentsCount'
    | 'canViewComments'
    | 'datePublished'
    | 'dateModified'
    | 'numViews'
    | 'postRegionName'
    | 'postCommentsUrl'
    | 'type'
  > {
  authorLink?: IAuthorsLinkSchema;
}

/**
 * Компонент информации о посте
 */
export const Details = ({
  authorPostsCount,
  authorId,
  authorLink,
  commentsCount,
  datePublished,
  dateModified,
  canViewComments,
  numViews,
  postRegionName,
  postCommentsUrl,
  type,
}: IDetails) => {
  const isUpdated = dateModified !== datePublished;
  const date = isUpdated ? dateModified : datePublished;

  return (
    <div className={s['wrapper']}>
      <DetailsComponent size="m">
        {type === EType.News && (
          <>
            <DateTimePublished isUpdated={isUpdated}>{date}</DateTimePublished>
            <NumViews>{numViews}</NumViews>
            <DetailsSeparator />
            {canViewComments && <PostCommentsCount link={postCommentsUrl} count={commentsCount || 0} />}
          </>
        )}

        {type === EType.Questions && (
          <>
            <DatePublished isUpdated={isUpdated}>{date}</DatePublished>
            <RegionName>{postRegionName}</RegionName>
            <NumViews>{numViews}</NumViews>
            <DetailsSeparator />
            {canViewComments && <PostCommentsCount link={postCommentsUrl} count={commentsCount || 0} />}
          </>
        )}

        {type === EType.Blogs && (
          <>
            <DatePublished isUpdated={isUpdated}>{date}</DatePublished>
            <NumViews>{numViews}</NumViews>
            <BlogLink authorId={authorId}>{authorPostsCount}</BlogLink>
            <DetailsSeparator />
            {canViewComments && <PostCommentsCount link={postCommentsUrl} count={commentsCount || 0} />}
          </>
        )}

        {type === EType.Articles && (
          <>
            {authorLink?.name && <AuthorLink name={authorLink.name} path={authorLink?.path || undefined} />}
            <DatePublished isUpdated={isUpdated}>{date}</DatePublished>
            <NumViews>{numViews}</NumViews>
            <DetailsSeparator />
            {canViewComments && <PostCommentsCount link={postCommentsUrl} count={commentsCount || 0} />}
          </>
        )}
      </DetailsComponent>
    </div>
  );
};
